import React from "react";

import Icon1 from "../../../assets/images/institueBannerBtmIcon1.svg";
import Icon2 from "../../../assets/images/institueBannerBtmIcon2.svg";
import Icon3 from "../../../assets/images/institueBannerBtmIcon3.svg";
import Icon4 from "../../../assets/images/institueBannerBtmIcon4.svg";
import Icon5 from "../../../assets/images/institueBannerBtmIcon5.svg";
import { useAuth } from "../../../context/AuthContext";
import styles from "./Banner.module.css";

export default function Banner({ userData }) {
  const { setAuthModal } = useAuth();
  const { logo, institution, address, memberSince, email, website } = userData;
  const formattedDate = new Date(`1 ${memberSince}`).toLocaleDateString(
    "en-US",
    { month: "short", year: "numeric" }
  );
  
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.logo}>
            <img src={logo} alt="institue Logo" />
          </div>
          <div className={styles.logoRight}>
            <div className={styles.focusArea}>
              <ul>
                <li>Hub</li>
                <li>University</li>
                <li>Active Mou</li>
              </ul>
            </div>
            <h1>{institution}</h1>
            <div className={styles.locationRow}>
              <p className={styles.location}>{address}</p>
              <p className={styles.calender}>Member Since {memberSince}</p>
              <p className={styles.time}>MoU valid till December 2025</p>
            </div>
            <div className={styles.actionBtn}>
              <button
                className={`${styles.button} ${styles.visitBtn}`}
                onClick={() => window.open(website, "_blank")}
              >
                Visit Website
              </button>
              <button
                className={`${styles.button} ${styles.emailBtn}`}
                onClick={() => (window.location.href = `mailto:${email}`)}
              >
                Email
              </button>
              <button
                className={`${styles.button} ${styles.partnerBtn}`}
                onClick={() => setAuthModal({ open: true, tab: "signup" })}
              >
                Partner with Us
              </button>
            </div>
          </div>
        </div>
        <div className={styles.heroActions}>
          <div className={styles.colum}>
            <div className={styles.icon}>
              <img src={Icon1} alt={"membership Start"} />
            </div>
            <p>
              <strong>{formattedDate}</strong>
              <br />
              membership Start
            </p>
          </div>
          <div className={styles.colum}>
            <div className={styles.icon}>
              <img src={Icon2} alt={"Events Hosted"} />
            </div>
            <p>
              <strong>47+</strong>
              <br />
              Events Hosted
            </p>
          </div>
          <div className={styles.colum}>
            <div className={styles.icon}>
              <img src={Icon3} alt={"Joint Publications"} />
            </div>
            <p>
              <strong>89</strong>
              <br />
              Joint Publications
            </p>
          </div>
          <div className={styles.colum}>
            <div className={styles.icon}>
              <img src={Icon4} alt={"Disciplines"} />
            </div>
            <p>
              <strong>12</strong>
              <br />
              Disciplines
            </p>
          </div>
          <div className={styles.colum}>
            <div className={styles.icon}>
              <img src={Icon5} alt={"Accreditation"} />
            </div>
            <p>
              <strong>NAAC A++</strong>
              <br />
              Accreditation
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
